import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import affiliates from './affiliates';
import affiliate from './affiliate';
import alumnis from './alumnis';
import alumni from './alumni';
import medals from './medals';
import medal from './medal';
import ageGroups from './ageGroups';
import entries from './entries';
import groupings from './groupings';
import hotels from './hotels';
import hotel from './hotel';
import seasonTypes from './seasonTypes';
import seasonHotels from './seasonHotels';
import sponsors from './sponsors';
import sponsor from './sponsor';
import tournaments from './tournaments';
import tournamentSeasons from './tournamentSeasons';
import tournament from './tournament';
import qas from './qas';
import qa from './qa';
import qasCategories from './qasCategories';
import contactEmailList from './contactEmailList';
import upcoming from './upcoming';
import past from './past';

const rootReducer = combineReducers({
    routing: routerReducer,
    affiliate,
    affiliates,
    alumnis,
    alumni,
    ageGroups,
    entries,
    groupings,
    hotels,
    hotel,
    medals,
    medal,
    qas,
    qa,
    seasonTypes,
    sponsor,
    sponsors,
    seasonHotels,
    tournaments,
    tournamentSeasons,
    tournament,
    qasCategories,
    contactEmailList,
    upcoming,
    past,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/index.js